import { LazyAction, LazyModule } from 'owa-bundling';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "AdalAuth", webpackPrefetch: true */ './lazyIndex')
);

export const lazyCreateAdalAuthenticationContext = new LazyAction(
    lazyModule,
    m => m.createAdalAuthenticationContext
);
